<template>
    <div class="Apple">     
        <img :src="require('@/commons/img/app_store.png')">
    </div>
</template>

<script>

import gsap from "gsap"
export default {
  name: 'Apple',
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Apple
    position relative
    display flex 
    align-items center
    justify-content center
    border 1px solid black
    border-radius 50%
    padding 5px
    background white
    border-radius 50%
    border 1px solid black

</style>


